export const APP_CONFIG = {
    NAME: 'CoffeePlexity',
    VERSION: '1.0.0',
    DESCRIPTION: 'The ultimate coffee community platform',
};
export const API_CONFIG = {
    BASE_URL: process.env['NEXT_PUBLIC_API_URL'] || 'http://localhost:4000',
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3,
};
export const PAGINATION = {
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
    MIN_LIMIT: 1,
};
export const VALIDATION_LIMITS = {
    USERNAME: {
        MIN_LENGTH: 3,
        MAX_LENGTH: 30,
    },
    PASSWORD: {
        MIN_LENGTH: 8,
        MAX_LENGTH: 128,
    },
    RECIPE_TITLE: {
        MIN_LENGTH: 1,
        MAX_LENGTH: 100,
    },
    RECIPE_DESCRIPTION: {
        MIN_LENGTH: 10,
        MAX_LENGTH: 2000,
    },
    BIO: {
        MAX_LENGTH: 500,
    },
    COMMENT: {
        MIN_LENGTH: 1,
        MAX_LENGTH: 1000,
    },
};
export const FILE_UPLOAD = {
    MAX_SIZE: {
        IMAGE: 10 * 1024 * 1024, // 10MB
        VIDEO: 100 * 1024 * 1024, // 100MB
        DOCUMENT: 5 * 1024 * 1024, // 5MB
    },
    ALLOWED_TYPES: {
        IMAGE: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
        VIDEO: ['video/mp4', 'video/webm', 'video/quicktime'],
        DOCUMENT: ['application/pdf', 'text/plain'],
    },
};
export const BREWING_METHODS = [
    { value: 'espresso', label: 'Espresso' },
    { value: 'pour_over', label: 'Pour Over' },
    { value: 'french_press', label: 'French Press' },
    { value: 'aeropress', label: 'AeroPress' },
    { value: 'cold_brew', label: 'Cold Brew' },
    { value: 'drip', label: 'Drip Coffee' },
    { value: 'moka_pot', label: 'Moka Pot' },
    { value: 'chemex', label: 'Chemex' },
    { value: 'v60', label: 'V60' },
    { value: 'siphon', label: 'Siphon' },
];
export const DIFFICULTY_LEVELS = [
    { value: 'beginner', label: 'Beginner', color: '#10b981' },
    { value: 'intermediate', label: 'Intermediate', color: '#f59e0b' },
    { value: 'advanced', label: 'Advanced', color: '#ef4444' },
    { value: 'expert', label: 'Expert', color: '#8b5cf6' },
];
export const GRIND_SIZES = [
    { value: 'extra_coarse', label: 'Extra Coarse' },
    { value: 'coarse', label: 'Coarse' },
    { value: 'medium_coarse', label: 'Medium Coarse' },
    { value: 'medium', label: 'Medium' },
    { value: 'medium_fine', label: 'Medium Fine' },
    { value: 'fine', label: 'Fine' },
    { value: 'extra_fine', label: 'Extra Fine' },
];
export const EQUIPMENT_CATEGORIES = [
    { value: 'grinders', label: 'Grinders' },
    { value: 'brewing_devices', label: 'Brewing Devices' },
    { value: 'espresso_machines', label: 'Espresso Machines' },
    { value: 'accessories', label: 'Accessories' },
    { value: 'scales', label: 'Scales' },
    { value: 'kettles', label: 'Kettles' },
    { value: 'filters', label: 'Filters' },
    { value: 'storage', label: 'Storage' },
];
export const SOCIAL_PLATFORMS = [
    { value: 'instagram', label: 'Instagram', icon: 'instagram' },
    { value: 'youtube', label: 'YouTube', icon: 'youtube' },
    { value: 'tiktok', label: 'TikTok', icon: 'tiktok' },
    { value: 'twitter', label: 'Twitter', icon: 'twitter' },
];
export const NOTIFICATION_TYPES = [
    { value: 'recipe_liked', label: 'Recipe Liked' },
    { value: 'recipe_commented', label: 'Recipe Commented' },
    { value: 'user_followed', label: 'User Followed' },
    { value: 'creator_approved', label: 'Creator Approved' },
    { value: 'payment_received', label: 'Payment Received' },
    { value: 'system_announcement', label: 'System Announcement' },
];
